import { EDITABLE_ITEM_TYPES, ItemType } from 'src/models/dto/items/ItemDTO'

/** Item types offered in the gallery picker — the editable item types plus StaticContentLayout. */
export const GALLERY_ITEM_TYPES: ItemType[] = Array.from(
    new Set<ItemType>([...EDITABLE_ITEM_TYPES, ItemType.StaticContentLayout])
)
